import React, { Component } from "react";
import { NavLink as RRNavLink, withRouter } from "react-router-dom";
import {
  Navbar,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu
} from "reactstrap";

import {
  routes,
  merchantRoute,
  dealRoute,
  usersdashBoard,
  useruploadContents,
  admindashBoard,
  adminverifiedContents,
  userdrafts,
  adminEventCreationRoute,
  adminBannerRoute,
  foodLibraryRoute,
  mealPlanRoute
} from "../../../_constants/routes.constants";

import PropTypes from "prop-types";
import {
  MdSettings,
  MdFileUpload,
  MdDashboard,
  MdContentCopy,
  MdContentPaste,
  MdLocalOffer,
  MdStore,
  MdEvent,
  MdCreditCard
} from "react-icons/md";
import{IoIosBasket} from "react-icons/io";
import "./SideMenus.scss";

class SideMenuComponent extends Component {
  matchNavPaths = routesArray => {
    const pathArray = routesArray.map(routes => routes.path);
    if (pathArray && pathArray.length) {
      if (pathArray.indexOf(this.props.location.pathname) > -1) {
        return true;
      }
    }
    return false;
  };

  render() {
    const { isFullWidth, role } = this.props;

    if (role === "ROLE_VLA_INSTRUCTOR") {
      return (
        <div>
          <Nav
            className={`sidebar ${isFullWidth ? "active" : ""}`}
            vertical
            navbar
          >
            {usersdashBoard.map(route => (
              <NavItem key={route.key}>
                <NavLink
                  tag={RRNavLink}
                  to={route.path}
                  onClick={() => this.props.showHeader(route.title)}
                >
                  <MdContentCopy size={20} className="mr-2" /> {route.title}
                </NavLink>
              </NavItem>
            ))}

            {userdrafts.map(route => (
              <NavItem key={route.key}>
                <NavLink
                  tag={RRNavLink}
                  to={route.path}
                  onClick={() => this.props.showHeader(route.title)}
                >
                  <MdContentPaste size={20} className="mr-2" /> {route.title}
                </NavLink>
              </NavItem>
            ))}

            {useruploadContents.map(route => (
              <NavItem key={route.key}>
                <NavLink
                  tag={RRNavLink}
                  to={route.path}
                  onClick={() => this.props.showHeader(route.title)}
                >
                  <MdFileUpload size={20} className="mr-2" /> {route.title}
                </NavLink>
              </NavItem>
            ))}
            <UncontrolledDropdown
              className={this.matchNavPaths(mealPlanRoute) ? "show" : ""}
              setActiveFromChild
            >
             <DropdownToggle
                tag="a"
                className={`nav-link ${
                  this.matchNavPaths(mealPlanRoute) ? "active" : ""
                }`}
                caret
              >
               <IoIosBasket size={20} className="mr-2" />Food Management
              </DropdownToggle>
              <DropdownMenu
                className={this.matchNavPaths(mealPlanRoute) ? "show" : ""}
              >
              {mealPlanRoute.map(route => (
              <div key={route.key}>
              {route.menu&&(<DropdownItem
                        tag={RRNavLink}
                        to={route.path}
                        onClick={() => this.props.showHeader(route.title)}
                      >
                        {route.title}
                      </DropdownItem>)}
              </div>))
            
            }
            </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
        </div>
      );
    } else if (role === "ROLE_VLA_ADMIN") {
      return (
        <div>
          <Nav
            className={`sidebar ${isFullWidth ? "active" : ""}`}
            vertical
            navbar
          >
            {admindashBoard.map(route => (
              <NavItem key={route.key}>
                <NavLink
                  tag={RRNavLink}
                  to={route.path}
                  onClick={() => this.props.showHeader(route.title)}
                >
                  <MdDashboard size={20} className="mr-2" /> {route.title}
                </NavLink>
              </NavItem>
            ))}

            {adminverifiedContents.map(route => (
              <NavItem key={route.key}>
                <NavLink
                  tag={RRNavLink}
                  to={route.path}
                  onClick={() => this.props.showHeader(route.title)}
                >
                  <MdContentCopy size={20} className="mr-2" /> {route.title}
                </NavLink>
              </NavItem>
            ))}
            {adminEventCreationRoute.map(route => (
              <NavItem key={route.key}>
                <NavLink
                  tag={RRNavLink}
                  to={route.path}
                  onClick={() => this.props.showHeader(route.title)}
                >
                  <MdEvent size={20} className="mr-2" /> {route.title}
                </NavLink>
              </NavItem>
            ))}

            {adminBannerRoute.map(route => (
              <NavItem key={route.key}>
                <NavLink
                  tag={RRNavLink}
                  to={route.path}
                  onClick={() => this.props.showHeader(route.title)}
                >
                  <MdCreditCard size={20} className="mr-2" /> {route.title}
                </NavLink>
              </NavItem>
            ))}

            <UncontrolledDropdown
              className={this.matchNavPaths(dealRoute) ? "show" : ""}
              setActiveFromChild
            >
              <DropdownToggle
                tag="a"
                className={`nav-link ${
                  this.matchNavPaths(dealRoute) ? "active" : ""
                }`}
                caret
              >
                <MdLocalOffer size={20} className="mr-2" /> Deals
              </DropdownToggle>
              <DropdownMenu
                className={this.matchNavPaths(dealRoute) ? "show" : ""}
              >
                {dealRoute.map(route => (
                  <div key={route.key}>
                    {route.menu && (
                      <DropdownItem
                        tag={RRNavLink}
                        to={route.path}
                        onClick={() => this.props.showHeader(route.title)}
                      >
                        {route.title}
                      </DropdownItem>
                    )}
                  </div>
                ))}
              </DropdownMenu>
            </UncontrolledDropdown>

            {merchantRoute.map(route => (
              <NavItem key={route.key}>
                <NavLink
                  tag={RRNavLink}
                  to={route.path}
                  onClick={() => this.props.showHeader(route.title)}
                >
                  <MdStore size={20} className="mr-2" /> {route.title}
                </NavLink>
              </NavItem>
            ))}
            <UncontrolledDropdown
              className={this.matchNavPaths(foodLibraryRoute) ? "show" : ""}
              setActiveFromChild
            >
             <DropdownToggle
                tag="a"
                className={`nav-link ${
                  this.matchNavPaths(foodLibraryRoute) ? "active" : ""
                }`}
                caret
              >
               <IoIosBasket size={20} className="mr-2" />Food Management
              </DropdownToggle>
              <DropdownMenu
                className={this.matchNavPaths(foodLibraryRoute) ? "show" : ""}
              >
              {foodLibraryRoute.map(route => (
              <div key={route.key}>
              {route.menu&&(<DropdownItem
                        tag={RRNavLink}
                        to={route.path}
                        onClick={() => this.props.showHeader(route.title)}
                      >
                        {route.title}
                      </DropdownItem>)}
              </div>))
            
            }
            </DropdownMenu>
            </UncontrolledDropdown>
            <UncontrolledDropdown
              className={this.matchNavPaths(routes) ? "show" : ""}
              setActiveFromChild
            >
              <DropdownToggle
                tag="a"
                className={`nav-link ${
                  this.matchNavPaths(routes) ? "active" : ""
                }`}
                caret
              >
                <MdSettings size={20} className="mr-2" /> Settings
              </DropdownToggle>
              <DropdownMenu
                className={this.matchNavPaths(routes) ? "show" : ""}
              >
                {routes.map(route => (
                  <div key={route.key}>
                    {route.menu && (
                      <DropdownItem
                        tag={RRNavLink}
                        to={route.path}
                        onClick={() => this.props.showHeader(route.title)}
                      >
                        {route.title}
                      </DropdownItem>
                    )}
                  </div>
                ))}
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
        </div>
      );
    } else {
      return (
        <div>
          <Nav
            className={`sidebar ${isFullWidth ? "active" : ""}`}
            vertical
            navbar
          />
        </div>
      );
    }
  }
}

Navbar.propTypes = {
  light: PropTypes.bool,
  dark: PropTypes.bool,
  fixed: PropTypes.string,
  color: PropTypes.string,
  role: PropTypes.string,
  expand: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string])
};

NavbarBrand.propTypes = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string])
};

export default withRouter(SideMenuComponent);
